import { useMemo } from 'react';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';

import InputField from 'dashboard/components/FormControls/InputField';
import Form from 'dashboard/layouts/FormLayout/Form';
import Section from 'dashboard/layouts/FormLayout/Section';
import Button from 'design-system/components/Button';
import { isRequired, withMessage } from 'lib/utils/formValidation';

const FORM_NAME = 'currentUserEmail';

interface FormCurrentUserEmailProps {}

const FormCurrentUserEmail = ({
  handleSubmit,
  submitting,
  pristine,
}: FormCurrentUserEmailProps & InjectedFormProps) => {
  const validate = useMemo((): Partial<Record<keyof FormCurrentUserEmailData, unknown>> => {
    return {
      emailAddress: [withMessage('Please enter a new email address', isRequired)],
      currentPassword: [withMessage('Please enter your current password', isRequired)],
    };
  }, []);

  return (
    <Form onSubmit={handleSubmit}>
      <Section cols={2} colsMobile={1}>
        <Field
          component={InputField}
          name='emailAddress'
          id='emailAddress'
          type='text'
          data-test='form-current-user-email-address__email-address'
          disclaimer='Persona highly discourages email addresses from free domains such as Gmail due to access to sensitive information.'
          disclaimerType='banner'
          disabled={submitting}
          validate={validate.emailAddress}
          placeholder='you@example.com'
          label='Email address'
        />
      </Section>
      <Section cols={2} colsMobile={1}>
        <Field
          component={InputField}
          name='currentPassword'
          id='currentPassword'
          type='password'
          validate={validate.currentPassword}
          disabled={submitting}
          placeholder='Confirm password'
          label='Confirm password'
        />
      </Section>
      <Section cols={3} colsMobile={1}>
        <Button
          type='submit'
          data-test='form-current-user-email__save'
          disabled={submitting || pristine}
          isPending={submitting}
        >
          Save changes
        </Button>
      </Section>
    </Form>
  );
};

export interface FormCurrentUserEmailData {
  emailAddress: string;
  currentPassword: string;
}

export default reduxForm<FormCurrentUserEmailData, FormCurrentUserEmailProps>({
  form: FORM_NAME,
  enableReinitialize: true,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
})(FormCurrentUserEmail);
